import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { MyCONST } from '../../CONST/myConst';

@Component({
  selector: 'app-view-details-repertoire',
  templateUrl: './view-details-repertoire.component.html',
  styleUrls: ['./view-details-repertoire.component.scss'],
})
export class ViewDetailsRepertoireComponent {
  tribunal: string = MyCONST.DETAIL_TRIBUNAL;
  data:any;

  constructor(private options: ModalOptions,private modalService: BsModalService,private datePipe: DatePipe){
    this.data = this.options.initialState.data;
    try{
      let tribunal_information:any = JSON.parse(localStorage.getItem('my_tribunal'))
      //console.log('tribunal_information====> ',tribunal_information)
      if(tribunal_information.code){
        //console.log('UPDATE')
        this.tribunal= tribunal_information.detail_tribunal
        // this.tribunal_detail= tribunal_information.detail_tribunal
      }
    }catch (e) {
      console.log('ERROR ON GET TRIBUNAL====> ')
    }
  }

  getFormattedDate(date): string {
    let res = date
    try{
      res =this.datePipe.transform(date, 'dd-MM-yyyy');
    }catch (e) {
      console.log('ERROR ON FORMAT ')
      res = date
    }
    return res
  }
}
